;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "g2qva9sytt"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
//Show/Hide menu in mobile
 var _this = jQuery(this);
 let $menu = _this.find('.lh-menu');
  _this.find('.lh-icon').click(function(e){
        $menu.toggleClass('open')     
    });
    _this.find('.lh-header-menu').click(function(e){
       let target = jQuery(e.target);
       if (!target.closest('.lh-menu').length){
       	$menu.removeClass('open');
   }
    });
   
 };						cb.bind($('section[data-section-id="g2qva9sytt"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="g2qva9sytt"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWFyLS0yMDIx/NjE1Mjc3MDI3/release-3-2021/pages/Sh7B9Vqrnv0tEDle/header/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "sxcs57gmnt"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="sxcs57gmnt"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="sxcs57gmnt"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"1"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "huvt9zr5o19"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="huvt9zr5o19"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="huvt9zr5o19"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"1"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "65cydm0prr6"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="65cydm0prr6"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="65cydm0prr6"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"1"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "oj3dnhnwgmi"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="oj3dnhnwgmi"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="oj3dnhnwgmi"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"1"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "nvfx5ngjn3"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="nvfx5ngjn3"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="nvfx5ngjn3"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "4d2cnu7xdfl"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="4d2cnu7xdfl"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="4d2cnu7xdfl"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "9xkiorhnjdm"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="9xkiorhnjdm"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="9xkiorhnjdm"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "4hrsliiceaz"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="4hrsliiceaz"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="4hrsliiceaz"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "97i5bp3aa7"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="97i5bp3aa7"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="97i5bp3aa7"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "7we174rurzp"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="7we174rurzp"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="7we174rurzp"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "q19g5a71c3"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="q19g5a71c3"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="q19g5a71c3"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "2rtd6ufzjdl"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="2rtd6ufzjdl"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="2rtd6ufzjdl"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "ymogbra3vd"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="ymogbra3vd"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="ymogbra3vd"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "9hnc3udibyw"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="9hnc3udibyw"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="9hnc3udibyw"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "wvbnnmwnhm"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="wvbnnmwnhm"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="wvbnnmwnhm"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "khl0pvfe5w"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="khl0pvfe5w"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="khl0pvfe5w"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "r3jutz5v2pd"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="r3jutz5v2pd"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="r3jutz5v2pd"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "bpg46k24j0b"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="bpg46k24j0b"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="bpg46k24j0b"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "bekf21qp8li"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="bekf21qp8li"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="bekf21qp8li"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "shl912xsvwb"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="shl912xsvwb"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="shl912xsvwb"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "fa6o2zcbs6u"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="fa6o2zcbs6u"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="fa6o2zcbs6u"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "zyga7l4zwp9"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="zyga7l4zwp9"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="zyga7l4zwp9"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "15a95b7e2dj"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="15a95b7e2dj"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="15a95b7e2dj"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "j15jl8vgfi"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="j15jl8vgfi"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="j15jl8vgfi"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "n12kwaea4sl"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="n12kwaea4sl"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="n12kwaea4sl"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "3mmglkofojg"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="3mmglkofojg"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="3mmglkofojg"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "krad6x8ba3q"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="krad6x8ba3q"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="krad6x8ba3q"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "wzukxsdlko"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="wzukxsdlko"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="wzukxsdlko"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "zckavvaf2z"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="zckavvaf2z"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="zckavvaf2z"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "3eiigynjjig"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="3eiigynjjig"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="3eiigynjjig"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "v2lxamdijij"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="v2lxamdijij"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="v2lxamdijij"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "p95q4wab9f"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="p95q4wab9f"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="p95q4wab9f"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "vpsmnsgiyk"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="vpsmnsgiyk"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="vpsmnsgiyk"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"3"}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');